import React from 'react';
import { Avatar as MaterialAvatar } from '@mui/material';

const stringAvatar = (name = '') => {
  const [first, second] = name.split(' ');

  return {
    bgcolor: 'primary.main',
    children: `${first?.[0]?.toUpperCase() || ''}${second?.[0]?.toUpperCase() || ''}`,
  };
};

const getDefaultStyling = (searchResult, width, height, fontSize, initialSX) => {
  return {
    boxSizing: 'border-box',
    border: 'none !important',
    p: 1,
    width: searchResult ? 25 : {width},
    height: searchResult ? 25 : {height},
    fontSize: searchResult ? '0.875rem' : `${fontSize}`,
    fontWeight: 500,
    bgcolor: 'grey.100',
    color: 'grey.500',
    alignSelf: 'center',
    ...initialSX
  }
}

export const Avatar = ({ name, sx = null, searchResult = false, width = 40, height = 40, fontSize = '1.125rem', initialSX={}  }) => {
  sx = getDefaultStyling(searchResult, width, height, fontSize, initialSX);
  return <MaterialAvatar sx={sx} {...stringAvatar(name)} />;
};
